// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"549ef5bce25204a53f92","883":"49a8e245e64a6ef54c43"}[chunkId] + ".js";
};